import React from "react";
import "../../sass/ui/tab.scss";

export const Tabs = ({ children }) => <div className="tabs-container">{children}</div>;
export const TabsList = ({ children }) => <div className="tabs-list">{children}</div>;
export const TabsTrigger = ({ children, onClick }) => (
  <button className="tabs-trigger" onClick={onClick}>{children}</button>
);
export const TabsContent = ({ children }) => <div className="tabs-content">{children}</div>;